import { render, staticRenderFns } from "./HomeQuotationDetail.vue?vue&type=template&id=4d52c28e&scoped=true&"
import script from "./HomeQuotationDetail.vue?vue&type=script&lang=js&"
export * from "./HomeQuotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomeQuotationDetail.vue?vue&type=style&index=0&id=4d52c28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52c28e",
  null
  
)

export default component.exports